export const app = {
  connectToYourWhatsappNumber: 'Conectar ao seu número de WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Conectar seu Bot do WhatsApp com seu número de WhatsApp',
  connect: 'Conectar',
};
